import { ThemeEvents } from '@theme/events';

class ProductSavingsBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSavingsBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSavingsBadge);
  }

  updateSavingsBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const position = this.dataset.savingsBadgePosition;
    const newSavingsBadge = event.detail.data.html.querySelector(
      `product-savings-badge[data-savings-badge-position="${position}"]`
    );

    if (!newSavingsBadge) return;

    if (this.innerHTML !== newSavingsBadge.innerHTML) {
      this.innerHTML = newSavingsBadge.innerHTML;
    }
  };
}

if (!customElements.get('product-savings-badge')) {
  customElements.define('product-savings-badge', ProductSavingsBadge);
}
